import React from "react";
import { Form } from "react-bootstrap";

export function WrapperCheckbox(props) {
    // https://react-bootstrap-v4.netlify.app/components/forms/#form-check-props

    if (!["checkbox", "radio", "switch", undefined].includes(props.type)) {
        return <div style={{ color: "red" }}>WrapperCheckbox error for type: '{props.type}'</div>;
    }

    const newProps = { ...props };
    newProps.type ||= "checkbox";
    if (newProps.checked === undefined) {
        newProps.checked = false;
    } else {
        newProps.checked = Boolean(newProps.checked);
    }
    return <Form.Check {...newProps} />;
}
